var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M60.767 30.617c6.608.81 11.733 6.447 11.733 13.273 0 5.933-8.641 21.826-12.032 27.833a1.544 1.544 0 01-2.683 0c-1.973-3.495-5.723-10.336-8.514-16.615a394.811 394.811 0 005.216-10.396 4.891 4.891 0 004.64 3.35 4.89 4.89 0 004.886-4.888 4.89 4.89 0 00-6.676-4.548 192.103 192.103 0 003.43-8.01z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    style: {
      fillRule: "evenodd"
    },
    d: "M14.233 30.617C7.625 31.427 2.5 37.064 2.5 43.89c0 5.933 8.641 21.826 12.031 27.833a1.544 1.544 0 002.684 0c1.972-3.495 5.722-10.336 8.513-16.615a394.811 394.811 0 01-5.215-10.396 4.891 4.891 0 01-4.64 3.35 4.89 4.89 0 01-4.887-4.888 4.89 4.89 0 016.677-4.548 192.103 192.103 0 01-3.43-8.01z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M44.3 47.975a343.747 343.747 0 01-3.515 6.521 3.776 3.776 0 01-6.659-.105c-5.12-9.327-14.379-27.074-14.379-34.15 0-9.797 7.955-17.751 17.753-17.751 9.797 0 17.752 7.954 17.752 17.752 0 3.268-1.975 8.811-4.607 14.75M37.5 12.805a6.49 6.49 0 016.487 6.487 6.49 6.49 0 01-6.487 6.487 6.49 6.49 0 01-6.487-6.487 6.49 6.49 0 016.487-6.487z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.ecc743a9af918f1569956ea523b61c62.svg";
export { ForwardRef as ReactComponent };